import React, { useState, useRef } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import FiltroProgettoDiCostituzione from '../FilterProgettoDiCostituzione';
import FiltroLeggi from '../FilterLeggi';
import FiltroDisegniDiLegge from '../FilterDisegniDiLegge';
import FiltroAttivitaNonLegislativa from '../FilterAttivitaNonLegislativa';
import RisultatiRicerca from '../RisultatiRicerca';
import { ProgressSpinner } from 'primereact/progressspinner';

function PaginaRicerca() {
    const risultatiRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const [searched, setSearched] = useState(false);
    const [searchLabel, setSearchLabel] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [resetKey, setResetKey] = useState(0);

    const handleSearchResults = ({ risultati = [], label = '' }) => {
        setResults(risultati);
        setSearchLabel(label);
        setSearched(true);
        setError('');

        setTimeout(() => {
            risultatiRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
    };

    const handleNuovaRicerca = () => {
        setSearched(false);
        setResults([]);
        setSearchLabel('');
        setError('');
        setResetKey((k) => k + 1);
    };

    const panels = [
        {
            header: 'Progetto di Costituzione',
            content: activeIndex === 0 ? (
                <FiltroProgettoDiCostituzione
                    key={resetKey}
                    onResults={handleSearchResults}
                    setLoading={setLoading}
                    setError={setError}
                    searched={searched}
                    onNuovaRicerca={handleNuovaRicerca}
                />
            ) : null,
        },
        {
            header: 'Disegni di Legge',
            content: activeIndex === 1 ? (
                <FiltroDisegniDiLegge
                    key={resetKey}
                    onResults={handleSearchResults}
                    setLoading={setLoading}
                    setError={setError}
                    searched={searched}
                    onNuovaRicerca={handleNuovaRicerca}
                />
            ) : null,
        },
        {
            header: 'Leggi',
            content: activeIndex === 2 ? (
                <FiltroLeggi
                    key={resetKey}
                    onResults={handleSearchResults}
                    setLoading={setLoading}
                    setError={setError}
                    searched={searched}
                    onNuovaRicerca={handleNuovaRicerca}
                />
            ) : null,
        },
        {
            header: 'Attività non legislativa',
            content: activeIndex === 3 ? (
                <FiltroAttivitaNonLegislativa
                    key={resetKey}
                    onResults={handleSearchResults}
                    setLoading={setLoading}
                    setError={setError}
                    searched={searched}
                    onNuovaRicerca={handleNuovaRicerca}
                />
            ) : null,
        },
    ];

    return (
        <div className="ml-2 mr-2 mb-4">
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                {panels.map((panel) => (
                    <TabPanel key={panel.header} header={panel.header}>
                        {panel.content}
                    </TabPanel>
                ))}
            </TabView>

            {loading && (
                <div className="flex justify-content-center mt-4">
                    <ProgressSpinner
                        style={{ width: '100px', height: '100px' }}
                        strokeWidth="4"
                    />
                </div>
            )}

            <RisultatiRicerca
                ref={risultatiRef}
                searched={searched}
                searchLabel={searchLabel}
                results={results}
                loading={loading}
                error={error}
            />
        </div>
    );
}

export default PaginaRicerca;
